var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxShadowNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    fillRule: "evenodd",
    d: "M0.538208 8.66256C0.538208 13.1499 4.17687 16.7886 8.66424 16.7886C13.1516 16.7886 16.7903 13.1499 16.7903 8.66256C16.7903 4.17428 13.1516 0.53653 8.66424 0.53653C4.17687 0.53653 0.538208 4.17428 0.538208 8.66256ZM4.89557 3.59734C5.94924 2.81272 7.25031 2.34231 8.66424 2.34231C12.1548 2.34231 14.9845 5.17198 14.9845 8.66256C14.9845 10.0774 14.515 11.3785 13.7295 12.4312L4.89557 3.59734ZM2.34399 8.66256C2.34399 7.2378 2.82162 5.9277 3.61617 4.87132L12.4555 13.7106C11.3982 14.5061 10.0881 14.9828 8.66424 14.9828C5.17366 14.9828 2.34399 12.1531 2.34399 8.66256Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxShadowNone);
export default __webpack_public_path__ + "static/media/box-shadow-none.18ffe10415c2ebde1b7ebf40c0a765f2.svg";
export { ForwardRef as ReactComponent };